export default [
  {
    entity: {
      id: 1,
      path: '/',
      name: 'systemManage',
      icon: 'el-icon-message\r\n',
      alias: '首页',
      discription: '用于系统管理的菜单',
    },
    childs: null,
  },
  {
    entity: {
      id: 1,
      path: '/enterprise/list',
      name: 'systemManage',
      icon: 'el-icon-message\r\n',
      alias: '企业列表',
      discription: '企业列表',
    },
    childs: null,
  },
  {
    entity: {
      id: 6,
      name: 'userManage',
      path: '/vehiclePosition',
      icon: 'el-icon-news',
      alias: '车辆位置管理',
      discription: '用于用户管理的菜单',
    },
    childs: [
      {
        entity: {
          id: 7,
          name: 'accountManage',
          path: '/vehiclePosition/moment',
          icon: 'el-icon-phone-outline\r\n',
          alias: '实时位置',
          discription: '实时位置',
        },
        childs: null,
      },
      {
        entity: {
          id: 8,
          name: 'integralManage',
          path: '/vehiclePosition/momentQuery',
          icon: 'el-icon-picture',
          alias: '实时位置查询',
          discription: '实时位置查询',
        },
        childs: null,
      },
      {
        entity: {
          id: 7,
          name: '',
          path: '/vehiclePosition/trajectory',
          icon: 'el-icon-phone-outline\r\n',
          alias: '车辆轨迹查询',
          discription: '用于帐号管理的菜单',
        },
        childs: [
          {
            entity: {
              id: 14,
              name: 'emailManage',
              path: '/vehiclePosition/trajectoryQuery',
              icon: 'el-icon-sold-out\r\n',
              alias: '单辆车查询轨迹',
              discription: '用于邮箱管理的菜单',
            },
            childs: null,
          },
        ],
      },
    ],
  },
  {
    entity: {
      id: 6,
      name: 'userManage',
      path: '/vehicleMonitoring',
      icon: 'el-icon-news',
      alias: '车辆监控管理',
      discription: '用于用户管理的菜单',
    },
    childs: [
      {
        entity: {
          id: 7,
          name: 'accountManage',
          path: '/vehicleMonitoring/list',
          icon: 'el-icon-phone-outline\r\n',
          alias: '车辆监控管理',
          discription: '用于帐号管理的菜单',
        },
        childs: null,
      },
    ],
  },
];
